import React from "react";
import { Bar } from "react-chartjs-2";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

dayjs.extend(utc);
dayjs.extend(timezone);

const SalesByTimeChart = ({ data }) => {
  const hourlySalesComparison = data?.hourlySalesComparison;
  if (!hourlySalesComparison) return null;

  const shiftedDataMap = new Array(24).fill(null).map(() => ({
    current: 0,
    previous: 0,
  }));

  hourlySalesComparison.forEach(({ hour, current, previous }) => {
    const phtHour = (hour + 8) % 24;
    shiftedDataMap[phtHour] = { current, previous };
  });

  const labels = Array.from(
    { length: 24 },
    (_, hour) =>
      `${hour % 12 === 0 ? 12 : hour % 12} ${hour < 12 ? "AM" : "PM"}`
  );

  const currentRangeData = shiftedDataMap.map((d) => d.current);
  const previousRangeData = shiftedDataMap.map((d) => d.previous);
  const maxValue = Math.max(...currentRangeData, ...previousRangeData);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Current Range",
        data: currentRangeData,
        backgroundColor: "#4CAF50",
      },
      {
        label: "Previous Range",
        data: previousRangeData,
        backgroundColor: "#9E9E9E",
      },
    ],
  };

  const options = {
    indexAxis: "x",
    responsive: true,
    plugins: {
      legend: { position: "top" },
      title: {
        display: true,
        text: "Sales by Time (Hourly Average)",
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const value = context.raw || 0;
            return `${context.dataset.label}: ₱${value.toLocaleString()}`;
          },
        },
      },
    },
    scales: {
      y: {
        suggestedMax: maxValue * 1.2,
        ticks: {
          callback: (val) => `₱${val.toLocaleString()}`,
        },
      },
    },
    elements: {
      bar: {
        barThickness: 30,
      },
    },
    categoryPercentage: 0.8,
    barPercentage: 0.9,
  };

  return <Bar data={chartData} options={options} />;
};

export default SalesByTimeChart;
